import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	else: {
		id: 'eoc.routing-rules.ui.else-card-content.else.no-translate',
		defaultMessage: 'ELSE',
		description: 'Label of last rule condition',
	},
	routeAllAlertsTo: {
		id: 'eoc.routing-rules.ui.else-card-content.route-all-alerts-to.no-translate',
		defaultMessage: 'route all alerts to',
		description: 'The label of latest rule condition',
	},
	routeAllAlertsToSingle: {
		id: 'eoc.routing-rules.ui.else-card-content.route-all-alerts-to-single.no-translate',
		defaultMessage: 'Route all alerts to',
		description: 'The label of latest rule condition',
	},
	routeTargetDeleted: {
		id: 'eoc.routing-rules.ui.else-card-content.route-target-deleted.no-translate',
		defaultMessage: 'Route Target Deleted',
		description: 'Label of route target deleted lozenge',
	},
	deletedEntity: {
		id: 'eoc.routing-rules.ui.else-card-content.deleted-entity.no-translate',
		defaultMessage: 'Deleted Entity',
		description: 'Plcaeholder of route target to selectbox when the entity is not exist anymore',
	},
});

export default messages;
